/**
 * Data layer for `igaming-geographic-jurisdiction-block-geo-exclusio`. Thin typed fetch wrappers over /api/v1/igaming-geographic-jurisdiction-block-geo-exclusio.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface IgamingGeographicJurisdictionBlockGeoExclusioRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListIgamingGeographicJurisdictionBlockGeoExclusioResponse {
	count: number;
	items: IgamingGeographicJurisdictionBlockGeoExclusioRow[];
}

export interface CreateIgamingGeographicJurisdictionBlockGeoExclusioBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/igaming-geographic-jurisdiction-block-geo-exclusio";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListIgamingGeographicJurisdictionBlockGeoExclusioResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListIgamingGeographicJurisdictionBlockGeoExclusioResponse>(res);
}

export async function create(body: CreateIgamingGeographicJurisdictionBlockGeoExclusioBody): Promise<IgamingGeographicJurisdictionBlockGeoExclusioRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<IgamingGeographicJurisdictionBlockGeoExclusioRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const igamingGeographicJurisdictionBlockGeoExclusioQueryKeys = {
	all: ["igaming-geographic-jurisdiction-block-geo-exclusio"] as const,
	list: () => [...igamingGeographicJurisdictionBlockGeoExclusioQueryKeys.all] as const,
	detail: (id: string) => [...igamingGeographicJurisdictionBlockGeoExclusioQueryKeys.all, id] as const,
};
